import { CSSProperties } from 'react';
import { mediaQuery, minBreakpoints } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export interface CSSVarInvertedRation extends CSSProperties {
  '--invertRatioMobile': string;
  '--invertRatioDesktop': string;
}

export interface CSSVarHeight extends CSSProperties {
  '--heightMobile': string;
  '--heightDesktop': string;
}

export const Picture = css`
  display: flex;
  height: 100%;

  &:before {
    content: '';
    display: block;
    padding-top: var(--invertRatioMobile, 0);
    ${mediaQuery(
      { min: minBreakpoints.MEDIUM },
      css`
        padding-top: var(--invertRatioDesktop, 0);
      `,
    )};
  }
`;

export const Image = css`
  display: block;
  width: 100%;
  height: var(--heightMobile, 100%);
  margin: 0 auto;
  object-fit: cover;
  object-position: center;
  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      height: var(--heightDesktop, 100%);
    `,
  )};
`;
